
import React from 'react';
import { MerchantList } from '../components/MerchantList';

const MerchantsPage: React.FC = () => {
  const handleCreateMerchant = () => {
    // Navigate to create merchant page
    window.location.href = '/merchants/create';
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center gap-4">
            <a
              href="/"
              className="text-sm text-muted-foreground hover:text-foreground"
            >
              ← Back to Home
            </a>
            <h1 className="text-2xl font-bold">ProPay Simulator Admin</h1>
          </div>
        </div>
      </header>
      <main className="container mx-auto px-4 py-8">
        <MerchantList onCreateMerchant={handleCreateMerchant} />
      </main>
    </div>
  );
};

export default MerchantsPage;
